import { localizeSystemText } from '../../i18n/messages';
import { PAYMENT_WATCHDOG_PRIORITY_OPTIONS, PAYMENT_WATCHDOG_FOLLOW_UP_STATUS_OPTIONS } from './clientSettlementWatchdog';

export function flagsToStatus({ showDraft, showApproved }) {
  if (showDraft === showApproved) return 'all';
  return showDraft ? 'draft' : 'approved';
}
export const statusToFlags = status => ({ showDraft: status === 'draft', showApproved: status === 'approved' });

export function activeSettlementFilters(filters, tr) {
  const result = [];
  const status = flagsToStatus(filters);
  if (status !== 'all') result.push({ key: 'status', label: tr(status === 'draft' ? 'billing:draft_123' : 'billing:approved_124'), clear: statusToFlags('all') });
  [
    ['showNegativeBalanceOnly', 'billing:underpaidOnly_125'],
    ['showEmptyClients', 'manage:extraAlsoShowClientsWithoutEntries_127'],
  ].forEach(([key, label]) => {
    if (filters[key]) result.push({ key, label: tr(label), clear: { [key]: false } });
  });
  const { watchdog } = filters;
  [
    ['enabledOnly', 'billing:overdueOnly_127', null],
    ['minAmount', 'billing:minimumOverdueAmount_128', null],
    ['minOverdueDays', 'billing:minimumDaysOverdue_129', null],
    ['priority', 'billing:priority_130', PAYMENT_WATCHDOG_PRIORITY_OPTIONS],
    ['followUpStatus', 'billing:handlingStatus_101', PAYMENT_WATCHDOG_FOLLOW_UP_STATUS_OPTIONS],
  ].forEach(([key, label, options]) => {
    const value = watchdog[key];
    if (!value || ((key === 'minAmount' || key === 'minOverdueDays') && Number(value) <= 0)) return;
    const option = options && options.find(item => item.value === value);
    const suffix = key === 'enabledOnly' ? '' : `: ${option ? localizeSystemText(option.text, tr) : value}`;
    result.push({ key, label: tr(label) + suffix, clear: { watchdog: { ...watchdog, [key]: key === 'enabledOnly' ? false : '' } } });
  });
  return result;
}
